import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefHistoryOBGyHistoryTypeOfARTDetailByID = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryTypeOfART/GetDetail?` + params, null);

export const GetRefHistoryOBGyHistoryTypeOfARTList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryTypeOfART/GetList?` + params, null);

export const CreateRefHistoryOBGyHistoryTypeOfART = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryTypeOfART/Create`, data);

export const UpdateRefHistoryOBGyHistoryTypeOfART = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryTypeOfART/Update`, data);

export const DeleteRefHistoryOBGyHistoryTypeOfART = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryTypeOfART/Delete`, data);